var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardNoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2455_7750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 10H7V1H11L10.9999 10Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87538 5.5C6.87538 3.74574 7.70619 2.18303 8.99991 1.17595C8.02063 0.412523 6.80941 -0.00181581 5.56231 5.98202e-06C2.49026 5.98202e-06 0 2.4624 0 5.5C0 8.5376 2.49026 11 5.56231 11C6.80944 11.0018 8.02069 10.5875 9 9.82405C7.70637 8.81715 6.87538 7.25435 6.87538 5.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.5C18 8.5376 15.5099 11 12.438 11C11.1908 11.0018 9.97944 10.5875 9 9.82405C10.294 8.81697 11.1248 7.25435 11.1248 5.5C11.1248 3.74565 10.294 2.18303 9 1.17595C9.97942 0.412546 11.1907 -0.00178387 12.4379 5.77336e-06C15.5098 5.77336e-06 17.9999 2.4624 17.9999 5.5",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2455_7750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardNoBorder);
export default __webpack_public_path__ + "static/media/mastercard-no-border.fd1a7d001dcfe0b75fc6a7466f37350c.svg";
export { ForwardRef as ReactComponent };